import { UpdateType } from "../../../backend/src/lib/types";
import { Background } from "./Background";
import { Bullet } from "./Bullet";
import { BulletType } from "./BulletType";
import { Engine } from "./Engine";
import { UpdateContext } from "./Entity";
import { L, logLevel } from "./log";
import { Player } from "./Player";
import { RemoteInterface } from "./RemoteInterface";
import { Renderer } from "./Renderer";

export class BulletController {
  private engine: Engine;
  private remote: RemoteInterface;
  bullets: Bullet[];

  constructor(engine: Engine) {
    this.engine = engine;
    this.remote = engine.remote;
    this.bullets = [];
  }

  spawnBullet = logLevel(
    L.INFO,
    (args: {
      x: number;
      y: number;
      vx: number;
      vy: number;
      type: BulletType;
      owner: Player;
      parentType?: BulletType;
      sourceRemote?: boolean;
      disableSpawnHook?: boolean;
    }) => {
      const {
        x: _x,
        y,
        vx,
        vy,
        type,
        parentType,
        owner,
        disableSpawnHook,
      } = args;
      const x =
        _x < 0
          ? _x + Background.WIDTH
          : _x > Background.WIDTH
          ? _x - Background.WIDTH
          : _x;
      const newBullet = new Bullet(
        this.engine,
        x,
        y,
        vx,
        vy,
        type,
        owner,
        parentType
      );
      this.bullets.push(newBullet);
      if (!args.sourceRemote) {
        if (!disableSpawnHook) type.spawnHook(newBullet, this.engine);
        this.remote.sendUpdate({
          type: UpdateType.BULLET_FIRED,
          x: x,
          y: y,
          vx: vx,
          vy: vy,
          bulletType: type.id,
          tick: this.remote.tick(),
          owner: owner.id,
        });
      }
      return newBullet;
    }
  );

  despawnBullet = logLevel(L.INFO, (bullet: Bullet) => {
    this.bullets = this.bullets.filter((x) => x != bullet);
  });

  update = logLevel(L.INFO, (ctx: UpdateContext) => {
    this.bullets.forEach((x) => x.update(ctx));
  });

  render = logLevel(L.INFO, (renderer: Renderer) => {
    this.bullets.forEach((x) => x.render(renderer));
  });
}
